module.exports = __webpack_public_path__ + "static/media/logout.bb5787d5.svg";